import { LocalStorageLruCache } from 'caches/LocalStorageLruCache';

export const RECENT_SEARCHES = 'recent-searches';

export const RecentSearchesCache = new LocalStorageLruCache({
  name: RECENT_SEARCHES,
});
